export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const CLEAR_ERROR_ACCOUNT_INVENTORY_SETTING = 'CLEAR_ERROR_ACCOUNT_INVENTORY_SETTING';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const EXECUTE_INVENTORY_START = 'EXECUTE_INVENTORY_START';
export const EXECUTE_INVENTORY_SUCCESS = 'EXECUTE_INVENTORY_SUCCESS';
export const EXECUTE_INVENTORY_FAILURE = 'EXECUTE_INVENTORY_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const SEARCH_UNASSIGNED_NODE_GROUPS_START = 'SEARCH_UNASSIGNED_NODE_GROUPS_START';
export const SEARCH_UNASSIGNED_NODE_GROUPS_SUCCESS = 'SEARCH_UNASSIGNED_NODE_GROUPS_SUCCESS';
export const SEARCH_UNASSIGNED_NODE_GROUPS_FAILURE = 'SEARCH_UNASSIGNED_NODE_GROUPS_FAILURE';

export const ADD_NODE_GROUPS_START = 'ADD_NODE_GROUPS_START';
export const ADD_NODE_GROUPS_SUCCESS = 'ADD_NODE_GROUPS_SUCCESS';
export const ADD_NODE_GROUPS_FAILURE = 'ADD_NODE_GROUPS_FAILURE';

export const REMOVE_NODE_GROUPS_START = 'REMOVE_NODE_GROUPS_START';
export const REMOVE_NODE_GROUPS_SUCCESS = 'REMOVE_NODE_GROUPS_SUCCESS';
export const REMOVE_NODE_GROUPS_FAILURE = 'REMOVE_NODE_GROUPS_FAILURE';

export const SEARCH_UNASSIGNED_NODE_DOMAINS_START = 'SEARCH_UNASSIGNED_NODE_DOMAINS_START';
export const SEARCH_UNASSIGNED_NODE_DOMAINS_SUCCESS = 'SEARCH_UNASSIGNED_NODE_DOMAINS_SUCCESS';
export const SEARCH_UNASSIGNED_NODE_DOMAINS_FAILURE = 'SEARCH_UNASSIGNED_NODE_DOMAINS_FAILURE';

export const ADD_NODE_DOMAINS_START = 'ADD_NODE_DOMAINS_START';
export const ADD_NODE_DOMAINS_SUCCESS = 'ADD_NODE_DOMAINS_SUCCESS';
export const ADD_NODE_DOMAINS_FAILURE = 'ADD_NODE_DOMAINS_FAILURE';

export const REMOVE_NODE_DOMAINS_START = 'REMOVE_NODE_DOMAINS_START';
export const REMOVE_NODE_DOMAINS_SUCCESS = 'REMOVE_NODE_DOMAINS_SUCCESS';
export const REMOVE_NODE_DOMAINS_FAILURE = 'REMOVE_NODE_DOMAINS_FAILURE';

export const UPDATE_SECURITY_GROUPS_START = 'UPDATE_SECURITY_GROUPS_START';
export const UPDATE_SECURITY_GROUPS_SUCCESS = 'UPDATE_SECURITY_GROUPS_SUCCESS';
export const UPDATE_SECURITY_GROUPS_FAILURE = 'UPDATE_SECURITY_GROUPS_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
